<template>
  <div>
    <template v-if="type === 'float'">
      <v-text-field
        outlined
        v-bind="$attrs"
        v-bind:required="required"
        v-bind:rules="rules"
        v-bind:value="modelValue"
        outline
        v-bind:class="itemClass"
        v-bind:label="label"
        hide-details
        v-on:change="setNumberModelValue"
        v-on:click:append="$emit('click:append', $event)">
        <template v-slot:append>
          <div v-if="numberTextFieldValue > 0" class="suffix">
            {{ suffix }}<sup v-if="supSuffix">{{ supSuffix }}</sup>
          </div>
        </template>
      </v-text-field>
    </template>

    <template v-else-if="type === 'int'">
      <v-text-field
        outlined
        v-bind="$attrs"
        v-bind:required="required"
        v-bind:rules="rules"
        v-bind:value="modelValue"
        outline
        v-bind:class="itemClass"
        v-bind:label="label"
        hide-details
        v-on:change="setNumberModelValue"
        v-on:click:append="$emit('click:append', $event)">
        <template v-slot:append>
          <div v-if="numberTextFieldValue > 0" class="suffix">
            {{ suffix }}<sup v-if="supSuffix">{{ supSuffix }}</sup>
          </div>
        </template>
      </v-text-field>
    </template>
    <template v-else>
      <v-text-field
        v-model="modelValue"
        outlined
        v-bind="$attrs"
        v-bind:required="required"
        v-bind:rules="rules"
        outline
        v-bind:label="label"
        v-bind:type="type"
        hide-details
        v-on:change="onChange"
        v-on:click:append="$emit('click:append', $event)" />
    </template>
  </div>
</template>

<script>
  export default {
    name: 'MTextField',
    inheritAttrs: false,
    model: {
      event: 'input',
      prop: 'value'
    },
    props: {
      label: { default: '', type: String },
      itemClass: { default: '', type: String },
      required: { default: false, type: Boolean },
      rules: { default: () => ([]), type: Array },
      textDateFormat: { default: 'DD.MM.YYYY', type: String },
      type: { default: 'text', type: String },
      suffix: { default: 'кг', type: String },
      supSuffix: { default: '', type: String },
      value: { default: '', type: [Array, String, Number] }
    },
    data() {
      return {
        numberTextFieldValue: null
      };
    },
    computed: {
      modelValue: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        }
      }
    },
    watch: {
      value() {
        if (this.type === 'float' || this.type === 'int') {
          this.setNumberModelValue();
        }
      }
    },

    created() {
      if (this.type === 'float' || this.type === 'int') {
        this.setNumberModelValue();
      }
    },
    methods: {
      onChange(value) {
        this.$emit('change', value);
      },
      setNumberModelValue(value) {
        if (!value) {
          return;
        }
        
        value = value.replace(/\s/g, '').replace(/,/g, '.');

        const checkIsNaN = parseInt(value);
        this.$nextTick(() => {
          if (this.type === 'float') {
            this.modelValue = isNaN(checkIsNaN) ? 0 : `${parseFloat(value).toFixed(2)}`;
          } else if (this.type === 'int') {
            this.modelValue = isNaN(checkIsNaN) ? 0 : parseInt(value);
          } else {
            this.modelValue  = isNaN(checkIsNaN) ? 0 : value;
          }
        });
      }
    }
  };
</script>
